export default __webpack_public_path__ + "media/zurb/img/services/tools/sketching-screenshot1-5c30918cfc1824b202ba43ab4a14cc8b.png";